import { combineReducers } from 'redux'

import destinationsReducer from './Alerts/reducer'
import alertsV2Reducer from './AlertsV2/reducer'
import creditsManagementReducer from './CreditsManagement/reducer'
import customizationReducer from './Customization/reducer'
import custO365NotificationsReducer from './CustomizationO365/Notifications/reducer'
import custO365ReportingReasonsReducer from './CustomizationO365/ReportingReasons/reducer'
import deepfakeGeneralReducer from './DeepFakeGeneral/reducer'
import disclaimersReducer from './Disclaimers/reducer'
import brandingReducer from './EmailEncryption/Branding/emailEncryptionBrandingReducer'
import emailEncryptionCompanyPoliciesReducer from './EmailEncryption/CompanyPolicies/emailEncryptionCompanyPoliciesReducer'
import integrationReducer from './EmailEncryption/Integration/emailEncryptionIntegrationReducer'
import settingsReducer from './EmailEncryption/Settings/emailEncryptionSettingsReducer'
import GsuiteReducer from './EmailServer/Gsuite/reducer'
import O365Reducer from './EmailServer/O365/reducer'
import quickIntegrationReducer from './EmailServer/QuickIntegration/reducer'
import emailServerReducer from './EmailServer/reducer'
import licensesReducer from './General/Licenses/reducer'
import generalReducer from './General/reducer'
import ignoreIpRangeReducer from './IgnoreIpRange/reducer'
import incidentResponseReducer from './Incidence/reducer'
import intelligenceReducer from './Intelligence/reducer'
import SpamAllowListReducer from './Intelligence/SpamAllowList/reducer'
import languagesReducer from './Languages/reducer'
import landingFormReducer from './MailboxProtection/LandingForm/reducer'
import mailboxProtectionReducer from './MailboxProtection/reducer'
import malwareDetectionReducer from './MalwareDetection/reducer'
import settingsMenuReducer from './Menu/reducer'
import microsoftQuarantineReducer from './MicrosoftQuarantine/reducer'
import collaborationAppsNotificationsReducer from './Notifications/CollaborationApps/reducer'
import endUserEditorReducer from './Notifications/EndUser/Editor/reducer'
import endUserLogoReducer from './Notifications/EndUser/Logo/reducer'
import endUserNotificationsReducer from './Notifications/EndUser/reducer'
import systemNotificationsReducer from './Notifications/System/reducer'
import partnerSettingsReducer from './PartnerSettings/reducer'
import pushNotificationsReducer from './ProfileSettings/PushNotifications/reducer'
import profileSettingsReducer from './ProfileSettings/reducer'
import simulatorReducer from './Simulator/reducer'
import usersReducer from './Users/reducer'
import whitelistReducer from './Whitelist/reducer'
import { GROUP_SETTINGS_NAME_REQUEST_ASYNC } from './constants'

export function groupSettingsReducer() {
  const initialState = {
    groupSettingsName: null,
    groupSettingsManagedFeatures: [],
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case GROUP_SETTINGS_NAME_REQUEST_ASYNC.SUCCESS: {
        const { data } = action.payload
        const isNameOnly = data === null || typeof data === 'string'
        return {
          ...state,
          groupSettingsName: isNameOnly ? data : data.name,
          groupSettingsManagedFeatures: isNameOnly ? [] : (data.managedFeatures ?? []),
        }
      }
      default:
        return state
    }
  }
}

export default function () {
  const initialState = combineReducers({
    self: groupSettingsReducer(),
    menu: settingsMenuReducer(),
    profileSettings: combineReducers({
      self: profileSettingsReducer(),
      pushNotifications: pushNotificationsReducer(),
    }),
    general: combineReducers({
      self: generalReducer(),
      licenses: licensesReducer(),
    }),
    users: combineReducers({
      self: usersReducer(),
    }),
    whitelist: combineReducers({
      self: whitelistReducer(),
    }),
    languages: combineReducers({
      self: languagesReducer(),
    }),
    partnerSettings: partnerSettingsReducer(),
    incidentResponse: combineReducers({
      self: incidentResponseReducer(),
    }),
    intelligence: combineReducers({
      self: intelligenceReducer(),
      spamAllowList: SpamAllowListReducer(),
    }),
    malwareDetection: combineReducers({
      self: malwareDetectionReducer(),
    }),
    simulator: combineReducers({
      self: simulatorReducer(),
      ignoreIpRange: ignoreIpRangeReducer(),
    }),
    emailServer: combineReducers({
      self: emailServerReducer(),
      quickIntegration: quickIntegrationReducer(),
      gsuite: GsuiteReducer(),
      o365: O365Reducer(),
    }),
    mailboxProtection: combineReducers({
      self: mailboxProtectionReducer(),
      landings: landingFormReducer(),
    }),
    alerts: combineReducers({
      destinations: destinationsReducer(),
    }),
    alertsV2: alertsV2Reducer(),
    notifications: combineReducers({
      enduser: endUserNotificationsReducer(),
      editor: endUserEditorReducer(),
      logo: endUserLogoReducer(),
      system: systemNotificationsReducer(),
      collaborationApps: collaborationAppsNotificationsReducer(),
    }),
    customization: combineReducers({
      self: customizationReducer(),
    }),
    customizationO365: combineReducers({
      notifications: custO365NotificationsReducer(),
      reportingReasons: custO365ReportingReasonsReducer(),
    }),
    disclaimers: combineReducers({
      self: disclaimersReducer(),
    }),
    microsoftQuarantine: combineReducers({
      self: microsoftQuarantineReducer(),
    }),
    deepfakeGeneral: combineReducers({
      self: deepfakeGeneralReducer(),
    }),
    emailEncryption: combineReducers({
      integration: integrationReducer,
      settings: settingsReducer,
      policies: emailEncryptionCompanyPoliciesReducer,
      branding: brandingReducer,
    }),
    creditsManagement: combineReducers({
      self: creditsManagementReducer(),
    }),
  })
  return (state = initialState, action) => {
    switch (action.type) {
      default:
        return state
    }
  }
}
